import { get, put } from ".";

export const myCartableAreas = () => {
  return get(`/api/region/user/myCartableAreas`, true);
};
export const getStaticAccesses = (areaId) => {
  return get(`/api/region/user/staticAccesses/${areaId}`, true);
};
export const checkAccessToWareHouseDrug = () => {
  return get(`/api/jahadgar/drug/checkAccessToWareHouse`, true);
};
export const checkAccessToWareHouseEquipment = () => {
  return get(`/api/jahadgar/equipment/checkAccessToWareHouse`, true);
};
export const hasExternalReferralAccess = () => {
  return get(
    `/api/jahadgar/external_referrals/hasExternalReferralAccess`,
    true
  );
};
export const getGroupAreas = () => {
  return get(`/api/region/manage/getGroupAreas`, true);
};
export const getGroupTrips = () => {
  return get(`/api/region/manage/getGroupTrips`, true);
};
export const getEquipmentCount = (areaId) => {
  return get(`/api/equipment/list/${areaId}`, true);
};
export const addAllEquipmentsToArea = (areaId, data) => {
  return put(
    `/api/jahadgar/equipment/addAllEquipmentsToArea/${areaId}`,
    true,
    data
  );
};
